import SessionHistory from './components/SessionHistory';
import React from 'react';
import { graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';
import gql from 'graphql-tag';

import LoginHOC from '../../../../components/LoginHOC';
import Spinner from '../../../../components/Spinner/';

const AdvisorSessions = gql`
query {
  listSessions {
    id
    scheduled_to
    module_instance_status {
      id
      name
    }
    module {
      module_name
      duration_minutes
      description
    }
    student {
      first_name
      last_name
    }
    Industry {
      name
    }
  }
}
`;

const mapStateToProps = (state) => ({
  authedUserID: state.auth.sub || null,
  authedUser: state.auth || null,
});

export default (store) => ({
  path: 'history',
  component: LoginHOC(connect(mapStateToProps)(compose(
    graphql(AdvisorSessions, {
      name: 'AdvisorSessions',
    }),
  )(props => { // Wait for schedule data
    if (props.AdvisorSessions.loading === false) {
      return <SessionHistory {...props} />;
    }
    return <Spinner />;
  }))),
});



// WEBPACK FOOTER //
// ./src/routes/scheduler/routes/SessionHistory/index.js